import Image from "next/image";

export default function WhoWeServeFeatureSection({
  eyebrow,
  title,
  description,
  bullets,
  imageSrc,
  imageAlt,
  align = "right",
  imageFit = "contain",
}: {
  eyebrow?: string;
  title: string;
  description: string;
  bullets?: string[];
  imageSrc: string;
  imageAlt: string;
  align?: "left" | "right";
  imageFit?: "contain" | "cover";
}) {
  const textOrder = align === "right" ? "lg:order-1" : "lg:order-2";
  const imageOrder = align === "right" ? "lg:order-2" : "lg:order-1";

  return (
    <section className="py-20 px-8 xl:px-0">
      <div className="max-w-6xl mx-auto grid lg:grid-cols-12 gap-10 items-center">
        <div className={`${textOrder} lg:col-span-5`}>
          {eyebrow ? (
            <p className="text-sm font-semibold text-blue-700 bg-blue-50 border border-blue-100 px-4 py-2 rounded-full w-fit">
              {eyebrow}
            </p>
          ) : null}
          <h2 className="text-3xl md:text-4xl font-medium text-slate-900 mt-4">
            {title}
          </h2>
          <p className="text-slate-700 leading-relaxed mt-3">{description}</p>
          {bullets?.length ? (
            <ul className="mt-6 space-y-3 text-slate-700">
              {bullets.map((b) => (
                <li key={b} className="flex gap-3">
                  <span className="text-green-600 font-bold">✓</span>
                  <span>{b}</span>
                </li>
              ))}
            </ul>
          ) : null}
        </div>

        <div className={`${imageOrder} lg:col-span-7`}>
          <div className="bg-white border border-slate-200 rounded-3xl p-4 md:p-6 shadow-xl shadow-slate-200/40">
            <div className="relative w-full overflow-hidden rounded-2xl border border-slate-200 bg-slate-50 h-[320px] md:h-[420px]">
              <Image
                src={imageSrc}
                alt={imageAlt}
                fill
                sizes="(max-width: 1024px) 100vw, 700px"
                className={
                  imageFit === "cover"
                    ? "object-cover object-center"
                    : "object-contain object-center"
                }
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
